import { type KnackFieldKey } from '@/types/schema/KnackField';
import {
  type SearchView,
  type SearchViewFilterRule,
  type SearchViewInput
} from '@/types/schema/views/SearchView';

function getParentSearchViewFieldInput(view: SearchView, parentFieldKey: KnackFieldKey) {
  let fieldInput: SearchViewInput | undefined;

  view.groups.forEach((group) => {
    group.columns.forEach((column) => {
      column.fields.forEach((field) => {
        if (field.connection && field.field === parentFieldKey) {
          fieldInput = field;
        }
      });
    });
  });

  return fieldInput;
}

export function useSearchViewParentInput({
  input,
  rules,
  view
}: {
  input: SearchViewInput;
  rules: SearchViewFilterRule[];
  view: SearchView;
}) {
  const parentFieldKey =
    input.source?.connections &&
    input.source.connections.length > 0 &&
    input.source.connections[0].source.type === 'input'
      ? input.source.connections[0].source.field.key
      : undefined;
  const parentSearchViewFieldInput = parentFieldKey
    ? getParentSearchViewFieldInput(view, parentFieldKey)
    : undefined;

  const parentInputSelectedRecordIds = rules.reduce((acc: string[], rule) => {
    if (!rule || !rule.value || typeof rule.value !== 'string') {
      return acc;
    }
    if (rule.field === parentFieldKey && rule.value) {
      acc.push(rule.value);
    }
    return acc;
  }, []);

  return { parentSearchViewFieldInput, parentInputSelectedRecordIds };
}
